import {SOPostTopic} from '../../core/topic/so-post-topic';
import {TopicCore} from './topic.core';
import {SOGetTopic} from '../../core/topic/so-get-topic';
import {FormField, SelectionOption} from 'lionheartland';
import {postTopicFormFieldOptions} from './post-topic-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostTopic extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postTopicFormFieldOptions);

  RequestClass = SOPostTopic

  constructor(
    public entityCore: TopicCore
  ) {
    super();
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
      this.getFormValueFromIdentifier('description'),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}